import React, { useEffect, useState } from 'react'
import { getConsent, setConsent, track, trackPageView } from '../services/analytics'

export default function ConsentBanner() {
  const [state, setState] = useState<'accepted' | 'rejected' | 'unknown'>('unknown')

  useEffect(() => {
    setState(getConsent())
  }, [])

  if (state !== 'unknown') return null

  const accept = () => {
    setConsent('accepted')
    track('consent_accepted', {})
    trackPageView()
    setState('accepted')
  }
  const reject = () => { setConsent('rejected'); setState('rejected') }

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Privacy notice"
      style={{
        position: 'fixed', left: 12, right: 12, bottom: 12, zIndex: 9999,
        background: '#111827', color: '#f9fafb',
        borderRadius: 10, padding: '14px 18px',
        boxShadow: '0 10px 25px rgba(0,0,0,.25)',
        display: 'flex', flexWrap: 'wrap', gap: 12,
        alignItems: 'center', justifyContent: 'space-between',
        font: '14px/1.4 system-ui, sans-serif',
      }}
    >
      <div style={{ flex: '1 1 320px', minWidth: 280 }}>
        We collect first-party page analytics to understand how visitors use LogiSelect.
        Allowing cookies lets us remember your browser preference; rejecting cookies does
        not disable analytics. No third-party trackers or ad networks.
        Read our{' '}
        <a href="/privacy" style={{ color: '#93c5fd', textDecoration: 'underline' }}>
          privacy notice
        </a>. You can opt out at any time.
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <button
          onClick={reject}
          style={{
            background: 'transparent', color: '#e5e7eb',
            border: '1px solid #6b7280', borderRadius: 6,
            padding: '8px 14px', cursor: 'pointer',
          }}
        >
          Reject cookies
        </button>
        <button
          onClick={accept}
          style={{
            background: '#2563eb', color: 'white', border: 'none',
            borderRadius: 6, padding: '8px 14px', cursor: 'pointer',
            fontWeight: 600,
          }}
        >
          Allow cookies
        </button>
      </div>
    </div>
  )
}
